import { render } from "./DrainOptions.vue?vue&type=template&id=2518e683&scoped=true"
import script from "./DrainOptions.vue?vue&type=script&lang=js"
export * from "./DrainOptions.vue?vue&type=script&lang=js"

import "./DrainOptions.vue?vue&type=style&index=0&id=2518e683&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2518e683"]])

export default __exports__